import PropertyStatus from "@/model/PropertyStatus";

const PROPERTY_STATUSES: PropertyStatus[] = [
  "LISTED",
  "UNLISTED",
  "MAINTENANCE",
];

export default PROPERTY_STATUSES;
